/**
 * A bridal couture show the house dressed — the jewellery on the ramp rather than
 * in the case. The client hand-off was 804 burst frames across four folders; these
 * are the keepers, one per look. Names match /assets/runway from the pipeline.
 *
 * `w` marks the true-landscape group frames so the masonry spans them.
 */

const R = (name, alt, w = false) => ({
  src: `/assets/runway/${name}.webp`,
  thumb: `/assets/runway/${name}-sm.webp`,
  alt,
  wide: w,
});

export const runwayPhotos = [
  R('runway-w-03', 'Looking down the mirrored ramp as the full line-up walks', true),
  R('runway-02', 'Ivory lehenga mid-turn, the skirt open on the gold ramp'),
  R('runway-06', 'Marigold lehenga with a polki choker and matched chandbali'),
  R('runway-09', 'Rose lehenga in motion, full skirt lifted'),
  R('runway-w-01', 'The colour story mid-show — rose, marigold and cobalt in line', true),
  R('runway-08', 'Emerald lehenga with a gold border and a layered polki suite'),
  R('runway-13', 'Ivory drape caught mid-turn under the chandeliers'),
  R('runway-05', 'Rose and marigold lehenga with a broad polki collar'),
  R('runway-w-02', 'Coral and crimson looks held in line for the finale', true),
  R('runway-14', 'Ivory lehenga, skirt lifted, long haar falling forward'),
  R('runway-07', 'Emerald and vermilion bandhani with a polki choker'),
  R('runway-15', 'Antique-gold bridal look with a maang tikka and nath'),
  R('runway-01', 'Gold tissue sari worn with a full polki suite'),
  R('runway-10', 'Ivory chikan lehenga from behind, haar across the back'),
  R('runway-w-04', 'The ivory finale walking together down the ramp', true),
  R('runway-16', 'Champagne lehenga with a long haar and stacked kada'),
  R('runway-03', 'Ivory and antique-rose bridal look with a layered collar'),
  R('runway-11', 'Ivory lehenga turning, dupatta held wide'),
  R('runway-12', 'Striped gota lehenga with a fine polki choker'),
  R('runway-04', 'Ivory sherwani with a jewelled kalgi at the safa'),
];

export const runwayMeta = {
  title: 'On the Ramp',
  eyebrow: 'The Runway',
  lede: 'A bridal couture show we dressed — the same closed-set polki, seen in motion under the lights.',
  /* Stated plainly because it is what the frames show: the house supplied the
     jewellery for the show, it did not stage the show or make the clothes. */
  note: 'Jewellery by Nikhil Jewellers. Garments by the designers showing.',
  count: runwayPhotos.length,
};
